import Vue from 'vue'
import VueRouter from 'vue-router'
const VueScrollTo = require('vue-scrollto')
import ga from 'vue-ga'
import VueToastr from "vue-toastr";
import VTooltip from 'v-tooltip'

import BlogDetail from '@/views/BlogDetail'
import Blog from '@/views/Blog'
import CharactersSingle from '@/views/CharactersSingle'
import CharactersUpgrade from '@/views/CharactersUpgrade'
import Characters from '@/views/Characters'
import Character from '@/views/Character'
import Contact from '@/views/Contact'
import Faq from '@/views/Faq'
import Guide from '@/views/Guide'
import Media from '@/views/Media'
import PreSale from '@/views/PreSale'
import Account from "@/views/Account";

Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(VueToastr)
Vue.use(VTooltip)

const routes = [
    {
        path: '/',
        alias: '/presale',
        name: 'PreSale',
        component: PreSale
    },
    {
        path: '/blog-detail',
        name: 'BlogDetail',
        component: BlogDetail
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog
    },
    {
        path: '/characters-single',
        name: 'CharactersSingle',
        component: CharactersSingle
    },
    {
        path: '/characters-upgrade',
        name: 'CharactersUpgrade',
        component: CharactersUpgrade
    },
    {
        path: '/characters',
        name: 'Characters',
        component: Characters
    },
    {
        path: '/character-upgrade',
        component: Character
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/faq',
        name: 'Faq',
        component: Faq
    },
    {
        path: '/guide',
        name: 'Guide',
        component: Guide
    },
    {
        path: '/media',
        name: 'Media',
        component: Media
    },
    {
        path: '/account',
        name: 'account',
        component: Account
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes
})

ga(router, 'G-CFP1BCY4T3')

export default router
